import { useId } from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlagContext } from 'restaurantAdmin/featureFlags';
import { SETTINGS_GENERAL_PATH } from 'restaurantAdmin/paths';
import { VipProgramSection } from '../general/vipProgramSection/VipProgramSection';

export const VipProgramPage = () => {
  const { isEnabled } = useFeatureFlagContext();
  const sectionTitleId = useId();

  if (!isEnabled('vipProgramCodes') && !isEnabled('vipProgramTiers')) {
    return <Navigate replace to={SETTINGS_GENERAL_PATH} />;
  }

  return <VipProgramSection sectionTitleId={sectionTitleId} variant="page" />;
};
